
import React from 'react';
import _ from 'underscore';
import { PreviewGeneral } from './preview-general';
import C from '../constants';

const getPreview = (
  image,
  previewTexts,
  i18n,
  isCurrent,
  isMultimediaAd = false,
  isMultiMediaAdsPhase2Enabled = false,
  isAdCreatorEnabled = false
) => { // eslint-disable-line max-len
  let propsToPass = {
    image,
    previewTexts,
    i18n,
    isCurrent,
    opacityChangeEnabled: isMultimediaAd,
    isMultimediaAd,
    isMultiMediaAdsPhase2Enabled,
    isAdCreatorEnabled,
  };

  const aspectRatios = isMultimediaAd ?
    C.getMmaAspectRatios() : C.aspectRatios;

  propsToPass = _.defaults(
    propsToPass,
    aspectRatios[image.Type].previewSettings
  );

  return (<PreviewGeneral {...propsToPass} />);
};

const getPreviewByType = (image, previewTexts, i18n, isCurrent, type) => {
  const typeConfig = C.imageAdExtSettings[type];
  const { previewTypeStringKey, imagePreviewHeight } = typeConfig;
  let propsToPass = {
    image,
    previewTexts,
    i18n,
    isCurrent,
    additionalSetting: typeConfig && {
      previewTypeStringKey,
      imagePreviewHeight,
    },
  };

  propsToPass = _.defaults(propsToPass, typeConfig && typeConfig.previewSettings);

  return (<PreviewGeneral {...propsToPass} />);
};

export {
  getPreview,
  getPreviewByType,
};
